export { default } from "./VisitDetails.gql";
